import { createContext } from 'react';

import type { IRateCalculatorContext } from '../DialogRateCalculator.helpers';

export const RateCalculatorContext = createContext<IRateCalculatorContext | null>(null);
